import styled from '@emotion/styled';

const IconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 10,
  fontSize: 28
});

export default IconWrapper;
